import Model, { ID } from 'src/models/model'

export const SHORTENED_URL_TYPES = {
  CUSTOM: 'Custom',
  PAGE: 'Page',
  DELIVERY_LOCATION: 'Delivery location',
  DELIVERY_TYPE: 'Delivery type',
  ALL: 'all'
}

export default class ShortenedUrl extends Model {
  static name = 'ShortenedUrl'

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Marketing]

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true
      },
      urlType: {
        type: String,
        default: SHORTENED_URL_TYPES.CUSTOM
      },
      description: {
        type: String,
        default: null
      },
      fullPath: {
        type: String,
        default: null
      },
      shortSlug: {
        type: String,
        default: null
      },
      shortUrl: {
        type: String,
        output: true
      }
    }
    this.paginate = true
  }
}
